module.exports = __webpack_public_path__ + "media/images/icn-search-grey-269b4b74b9db7bfa35e234e42e7a541b.png";